import { pickerStyles as picker } from './select-styles';
export const shouldDisableCountryPicker = false;
export const pickerStyles = picker;